// this file is automatically generated by prebuild.config.ts script
export const config = {
  'API_ROOT': 'https://backend.luciana.app/v2',
  'TESTING': 'false',
  'DYNAMIC_ENV': true
};



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/environments/config.ts